import Axios from 'axios';

// Internal-only page events (dwell time, clicks that never reach the API). The server derives
// org, customer and session from the auth token, so only event rows are sent. Every call is
// fire-and-forget: tracking must never break the payment page.

let dwellStart = Date.now();
let dwellLastSentAt = 0;
let dwellListenersAttached = false;

function authHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  const auth = Axios.defaults.headers.common.Authorization;
  const shortToken = Axios.defaults.headers.common['x-ck-short-token'];
  if (auth) headers.Authorization = auth;
  if (shortToken) headers['x-ck-short-token'] = shortToken;
  return headers;
}

export function trackPageEvent(event, data) {
  try {
    Axios.post('/orgs/dunning/events', { events: [{ event, ts: Date.now(), data }] }).catch(() => {});
  } catch (e) {
    // never surface tracking errors
  }
}

// Cumulative seconds on page, sent on every hide so the last value wins. fetch with keepalive
// instead of Axios: it survives page unload, and sendBeacon cannot carry the auth header.
function sendDwell() {
  // pagehide and visibilitychange fire together on navigation; one report is enough.
  if (Date.now() - dwellLastSentAt < 1000) return;
  const seconds = Math.round((Date.now() - dwellStart) / 1000);
  if (seconds < 1) return;
  dwellLastSentAt = Date.now();
  try {
    fetch(`${Axios.defaults.baseURL}/orgs/dunning/events`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ events: [{ event: 'Recovery Page Time On Page', ts: Date.now(), data: { seconds } }] }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // never surface tracking errors
  }
}

export function initDwellTracking() {
  dwellStart = Date.now();
  if (dwellListenersAttached) return;
  dwellListenersAttached = true;
  window.addEventListener('pagehide', sendDwell);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') sendDwell();
  });
}
